import React, { useEffect, useState, useRef } from "react";
import { Col, Input, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RiArrowLeftSLine,
  // RiCloseLine,
  // RiFolderFill,
} from "react-icons/ri";
import {
  setRadius,
  setSearchTerm,
  setSelectedSubCategory,
  setSelectedItem,
  setActiveTab,
  setViewCustType,
  setCurrentPage,
  setSearchQuery,
  setSearchText,
} from "../../../../redux/slices/LcaSlice";
import {
  RiFolderFill,
  RiBriefcaseFill,
  RiHome4Fill,
  RiStoreFill,
  // RiGemFill,
  RiHeartFill,
  RiStarFill,
  RiCalendarFill,
  RiArrowDownDoubleFill,
  RiRecordCircleFill,
} from "react-icons/ri";
import "../../../../components/Layout/Prosidebar.css";
import Tooltip from "../../../Layout/tooltip";
import SidebarLoading from "../../../Layout/SidebarLoading";
import ZipcodeFilter from "../../WeddingVendors/ZipcodeFilter";
import BusinessFilter from "../../WeddingVendors/BusinessFilter";

const ANIMATION_DURATION = 300;

const getIconForName = (name) => {
  if (!name) return <RiFolderFill />;

  const nameLower = name.toLowerCase();
  if (nameLower === "job market") {
    return <RiBriefcaseFill />;
  } else if (nameLower === "real estate") {
    return <RiHome4Fill />;
  } else if (nameLower === "local business ads") {
    return <RiStoreFill />;
  } else if (nameLower === "highlight") {
    return <RiStarFill />;
  } else if (nameLower === "matrimony") {
    return <RiHeartFill />;
  } else if (nameLower === "event businesses & customers") {
    return <RiCalendarFill />;
  } else {
    return <RiFolderFill />;
  }
};

const LcaSideBar = ({
  items = [],
  productSubCat = [],
  setScrollPopupVisible,
  collapsed,
  setCollapsed,
  toggled,
  setToggled,
  isMobileView,
  isTabletView,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    searchTerm,
    selectedSubCategory,
    selectedItem,
    radius,
    viewCustType,
  } = useSelector((state) => state.lcAds);

  const { loading } = useSelector((state) => state.lcaAndVendors);

  const initialCategoriesToShow = 6;
  const popupRef = useRef();
  const sidebarRef = useRef(null);
  const subMenuRefs = useRef({});
  const firstSubMenuBtnRefs = useRef({});
  const [showPopup, setShowPopup] = useState(false);

  const safeProductSubCat = Array.isArray(productSubCat) ? productSubCat : [];
  const safeItems = Array.isArray(items) ? items : [];
  const [visibleCategories, setVisibleCategories] = useState(
    safeProductSubCat.slice(0, 6)
  );
  const [showRemainingCategories, setShowRemainingCategories] = useState(false);
  const [tempRadius, setTempRadius] = useState(radius);
  const [openSubmenus, setOpenSubmenus] = useState(new Set());

  // Show loading if data is still being fetched
  const isDataLoading = safeProductSubCat.length === 0;

  function tglHide() {
    const hdel = document.getElementById("lca-sidebar");
    if (hdel) {
      hdel.classList.remove("tgl-show");
      hdel.classList.add("tgl-close");
    }
    setToggled(false);
  }

  const handlePopUpClick = () => {
    window.scrollTo(0, 0);
    if (setScrollPopupVisible) {
      setScrollPopupVisible(true);
    }
  };

  const handleSubCategoryClick = (category, e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPopup(false);
    if (!category) return;
    dispatch(setCurrentPage(1));
    dispatch(setSearchQuery(""));
    dispatch(setSearchText(""));
    handlePopUpClick();
    dispatch(setRadius(15));
    const searchParams = new URLSearchParams(location.search);
    const isCurrentlySelected =
      selectedSubCategory && selectedSubCategory.id === category.id;

    if (isCurrentlySelected) {
      // Deselect category
      dispatch(setSelectedSubCategory(null));
      dispatch(setSelectedItem(null));
      dispatch(setActiveTab("Customers"));
      searchParams.delete("subcategory");
      searchParams.delete("item");

      // Close submenu
      setOpenSubmenus((prev) => {
        const newSet = new Set(prev);
        newSet.delete(category.id);
        return newSet;
      });

      // const submenuElement = subMenuRefs.current[category.id];
      // if (submenuElement) {
      //   slideUp(submenuElement);
      // }
    } else {
      // ✅ Select new category using `id` internally but `Name` for URL
      dispatch(setSelectedSubCategory(category));
      dispatch(setSelectedItem(null)); // Clear any selected item
      searchParams.set("subcategory", category.Name || "");
      searchParams.delete("item");
      // Clear category from URL
      searchParams.delete("category");

      // ✅ Business logic based on `id`
      if (category.id === 63) {
        dispatch(setActiveTab("Vendor"));
      } else {
        dispatch(setActiveTab("Customers"));
      }

      // Manage submenus
      setOpenSubmenus(new Set([category.id]));
    }

    // ✅ Update URL with Name-based query param
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: true }
    );

    // Responsive behavior
    if (isMobileView || isTabletView) {
      if (!toggled) setToggled(true);
    } else if (collapsed && !isCurrentlySelected) {
      setCollapsed(false);
    }
  };

  const handleItemClick = (item, ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (!item) return;

    dispatch(setCurrentPage(1));

    const searchParams = new URLSearchParams(location.search);
    const isCurrentlySelected =
      selectedItem && selectedItem.subCatItemName === item.subCatItemName;

    if (isCurrentlySelected) {
      // Deselect item
      dispatch(setSelectedItem(null));
      searchParams.delete("item");
      dispatch(setSearchQuery(""));
      dispatch(setSearchText(""));
      searchParams.delete("category");
      // Keep subcategory in URL by Name
      if (selectedSubCategory) {
        searchParams.set("subcategory", selectedSubCategory.Name || "");
      }
    } else {
      // ✅ Select new item — store `id` internally but `Name` in URL
      dispatch(setSelectedItem(item));
      searchParams.set("item", item.subCatItemName || "");

      if (selectedSubCategory) {
        searchParams.set("subcategory", selectedSubCategory.Name || "");
      }
    }

    // ✅ Update URL (Name-based)
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: true }
    );

    // Close sidebar in mobile view
    if (isMobileView) tglHide();
  };

  const handleRadiusChange = (event) => {
    const newRadius = Number.parseInt(event.target.value, 10);
    if (!isNaN(newRadius)) {
      setTempRadius(newRadius);
    }
  };

  const handleRadiusCommit = () => {
    if (tempRadius >= 0) {
      dispatch(setRadius(tempRadius));
      dispatch(setCurrentPage(1));
    }
  };

  const slideDown = (target, duration = ANIMATION_DURATION) => {
    if (!target) return;

    const parentElement = target.parentElement;
    if (parentElement) {
      parentElement.classList.add("psb-open", "sidebar-open");
    }

    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
    if (display === "none") display = "block";
    target.style.display = display;
    const height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = "0";
    target.style.paddingTop = "0";
    target.style.paddingBottom = "0";
    target.style.marginTop = "0";
    target.style.marginBottom = "0";
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = `${duration}ms`;
    target.style.height = `${height}px`;
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");

    setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
    }, duration);
  };

  const handleCollapse = () => {
    setCollapsed((prev) => !prev);
    if (!collapsed) {
      // Close all submenus when collapsing
      setOpenSubmenus(new Set());
      Object.values(firstSubMenuBtnRefs.current).forEach((element) => {
        if (element && element.parentElement) {
          element.parentElement.classList.remove("psb-open", "sidebar-open");
        }
      });
    }
  };

  // Initialize URL state on mount
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const subcategoryName = searchParams.get("subcategory");
    const itemName = searchParams.get("item");

    if (subcategoryName && safeProductSubCat.length > 0) {
      const matchingCategory = safeProductSubCat.find(
        (category) =>
          category &&
          category.Name &&
          category.Name.toLowerCase() === subcategoryName.toLowerCase()
      );

      if (
        matchingCategory &&
        (!selectedSubCategory || selectedSubCategory.id !== matchingCategory.id)
      ) {
        dispatch(setSelectedSubCategory(matchingCategory));
        setOpenSubmenus(new Set([matchingCategory.id]));

        if (matchingCategory.id === 63) {
          dispatch(setActiveTab("Vendor"));
        } else {
          dispatch(setActiveTab("Customers"));
        }
      }
    }

    if (itemName && safeItems.length > 0) {
      const matchingItem = safeItems.find(
        (item) =>
          item &&
          item.subCatItemName &&
          item.subCatItemName.toLowerCase() === itemName.toLowerCase()
      );

      if (
        matchingItem &&
        (!selectedItem ||
          selectedItem.subCatItemId !== matchingItem.subCatItemId)
      ) {
        dispatch(setSelectedItem(matchingItem));
      }
    }
  }, [location.search, safeProductSubCat, safeItems, dispatch]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const subcategoryName = searchParams.get("subcategory");

    if (!subcategoryName) {
      dispatch(setSelectedSubCategory(null));
      dispatch(setSelectedItem(null));
      setOpenSubmenus(new Set()); // Close any open submenus
    }
  }, [location.search, dispatch]);
  // Handle submenu visibility based on selected category
  useEffect(() => {
    if (selectedSubCategory && subMenuRefs.current[selectedSubCategory.id]) {
      const submenuElement = subMenuRefs.current[selectedSubCategory.id];
      if (!openSubmenus.has(selectedSubCategory.id)) {
        setOpenSubmenus((prev) => new Set([...prev, selectedSubCategory.id]));
        slideDown(submenuElement);
      }
    }
  }, [selectedSubCategory, openSubmenus]);

  // Other useEffects remain the same...
  useEffect(() => {
    dispatch(setRadius(15));
    dispatch(setCurrentPage(1));
  }, [searchTerm, selectedSubCategory, selectedItem, dispatch]);

  useEffect(() => {
    if (viewCustType && safeProductSubCat.length > 0) {
      const filterSubCat = safeProductSubCat.filter(
        (item) => item && item.id === 63
      );
      if (filterSubCat.length > 0) {
        dispatch(setSelectedSubCategory(filterSubCat[0]));
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("subcategory", filterSubCat[0].Name || "");
        navigate(
          { pathname: location.pathname, search: searchParams.toString() },
          { replace: true }
        );
        dispatch(setActiveTab("Customers"));
        window.scrollTo(0, 0);
      }
      dispatch(setViewCustType(false));
    }
  }, [viewCustType, safeProductSubCat, location.search]);

  useEffect(() => {
    setVisibleCategories(
      showRemainingCategories
        ? safeProductSubCat
        : safeProductSubCat.slice(0, 6)
    );
  }, [safeProductSubCat, showRemainingCategories]);

  useEffect(() => {
    setTempRadius(radius);
  }, [radius]);

  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (isMobileView || isTabletView) &&
        toggled &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".psb-mobile-trigger")
      ) {
        setToggled(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [toggled, isMobileView, isTabletView, setToggled]);

  const Popup = ({ closePopup }) => (
    <div
      className="text-center wc_show_cat_popup d-lg-none d-xl-block d-none"
      style={{ position: "absolute", top: "10px", left: "140px" }}
    >
      <div
        ref={popupRef}
        style={{
          padding: "10px",
          backgroundColor: "var(--theme-light)",
          borderRadius: "8px",
          boxShadow: "0 4px 8px var(--theme-shadow)",
          color: "var(--white)",
          zIndex: 999,
          width: 120,
          display: "flex",
          flexDirection: "row",
          animation: "flashingColor 2s infinite",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            textWrap: "nowrap",
          }}
        >
          Select to view
        </div>
        <div
          style={{
            marginTop: "-5px",
            textAlign: "center",
          }}
          onClick={closePopup}
        >
          <RiArrowDownDoubleFill size={20} />
        </div>
      </div>
    </div>
  );

  return (
    <aside
      id="lca-sidebar"
      className={`psb-sidebar psb-has-bg-image ${
        collapsed && !isMobileView && !isTabletView
          ? "psb-collapsed-desktop"
          : ""
      } ${toggled ? "psb-toggled" : ""}`}
      ref={sidebarRef}
    >
      <div className="psb-layout px-4 pb-5">
        <div className="psb-content">
          {(isMobileView || isTabletView) && toggled && (
            <div
              className="psb-mobile-close-btn text-2xl p-1 cursor-pointer"
              onClick={() => setToggled(false)}
            >
              <RiArrowLeftSLine />
            </div>
          )}
          <nav className="psb-menu psb-open-current-submenu">
            {isDataLoading ? (
              <SidebarLoading
                collapsed={collapsed}
                isMobileView={isMobileView}
                isTabletView={isTabletView}
                toggled={toggled}
                itemCount={6}
              />
            ) : (
              <ul>
                <li className="psb-menu-header">
                  <span className="sidebar-header-text">ADS CATEGORIES</span>
                </li>
                {(visibleCategories || []).map((category) => {
                  if (!category) return null;

                  const isSelected =
                    selectedSubCategory &&
                    selectedSubCategory.id === category.id;
                  const isOpen = openSubmenus.has(category.id);

                  return (
                    <li
                      key={category.id}
                      className={`sidebar-item submenu ${
                        isSelected ? "sidebar-item-active sidebar-open" : ""
                      }`}
                      onClick={(e) => handleSubCategoryClick(category, e)}
                      style={{
                        listStyle: "none",
                        backgroundColor: isSelected ? "whitesmoke" : "",
                        borderRadius: "4px",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <Tooltip
                        text={category.Name || "Unnamed Category"}
                        visible={
                          (collapsed && !toggled && !isMobileView) ||
                          (isTabletView && !toggled)
                        }
                      >
                        <div
                          className={`sidebar-link-content ${
                            collapsed ? "" : " "
                          }`}
                          ref={(el) =>
                            (firstSubMenuBtnRefs.current[category.id] = el)
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding:
                              (collapsed && !isMobileView && !isTabletView) ||
                              (isTabletView && !toggled)
                                ? "15px 8px"
                                : "10px 15px",
                            color: isSelected
                              ? "var(--button-bg)"
                              : "var(--text-primary)",
                            fontSize: "medium",
                            textDecoration: "none",
                            fontWeight: 600,
                            transition: "all 0.5s ease",
                            borderRadius: "5px",
                            justifyContent: !collapsed
                              ? "flex-start"
                              : "center",
                            width: "100%",
                            minHeight: "40px",
                          }}
                        >
                          <span
                            className="sidebar-icon"
                            style={{
                              display: "inline-block",
                              color: isSelected
                                ? "var(--button-bg)"
                                : "var(--text-secondary)",
                              transition: "all 0.3s ease",
                            }}
                          >
                            {getIconForName(category.Name)}
                          </span>
                          <span
                            className="sidebar-title mt-1"
                            style={{
                              marginLeft:
                                (collapsed && !isMobileView && !isTabletView) ||
                                (isTabletView && !toggled)
                                  ? "0px"
                                  : "10px",
                              color: isSelected
                                ? "var(--button-bg)"
                                : "var(--text-secondary)",
                              transition: "color 0.5s ease",
                              display:
                                (collapsed && !isMobileView && !isTabletView) ||
                                (isTabletView && !toggled)
                                  ? "none"
                                  : "inline",
                            }}
                          >
                            {category.Name || "Unnamed Category"}
                          </span>
                        </div>
                      </Tooltip>
                      <div
                        className="submenu-list"
                        style={{
                          display:
                            isSelected && !collapsed && isOpen
                              ? "block"
                              : "none",
                          paddingLeft: "5px",
                          overflow: "hidden",
                          paddingRight: "8px",
                          transition: "all 0.5s ease",
                        }}
                        ref={(el) => (subMenuRefs.current[category.id] = el)}
                      >
                        <ul style={{ padding: 0, margin: 0 }}>
                          {safeItems
                            .filter(
                              (item) => item && item.subCatId === category.id
                            )
                            .map((item) => {
                              const isItemSelected =
                                selectedItem?.subCatItemName ===
                                item.subCatItemName;

                              return (
                                <li
                                  key={item.id}
                                  className={`submenu-item ${
                                    isItemSelected ? "submenu-item-active" : ""
                                  }`}
                                  onClick={(ev) => handleItemClick(item, ev)}
                                  style={{
                                    listStyle: "none",
                                    padding: "8px 15px",
                                    color: isItemSelected
                                      ? "var(--white)"
                                      : "var(--text-secondary)",
                                    cursor: "pointer",
                                    backgroundColor: isItemSelected
                                      ? "var(--button-bg)"
                                      : "transparent",
                                    borderRadius: "4px",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    transition: "all 0.3s ease",
                                    minHeight: "32px",
                                  }}
                                >
                                  <RiRecordCircleFill
                                    size={8}
                                    color={
                                      isItemSelected
                                        ? "var(--white)"
                                        : "var(--text-secondary)"
                                    }
                                  />
                                  <span
                                    className="submenu-title"
                                    style={{
                                      color: isItemSelected
                                        ? "var(--white)"
                                        : "var(--text-secondary)",
                                      transition: "color 0.5s ease",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {item.subCatItemName || "Unnamed Item"}
                                  </span>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </li>
                  );
                })}

                {/* Show More/Less buttons */}
                {!showRemainingCategories && safeProductSubCat.length > 6 && (
                  <li
                    className="show-more"
                    onClick={() => setShowRemainingCategories(true)}
                    style={{
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display: collapsed ? "none" : "flex",
                        justifyContent: "flex-end",
                        padding: "10px 15px",
                        color: "var(--text-primary)",
                        fontSize: "medium",
                        textDecoration: "none",
                        fontWeight: 600,
                        transition: "all 0.5s ease",
                        borderRadius: "5px",
                        minHeight: "40px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className="mt-1"
                        style={{
                          color: "var(--text-secondary)",
                          transition: "color 0.5s ease",
                        }}
                      >
                        Show More
                      </span>
                    </div>
                  </li>
                )}
                {showRemainingCategories && safeProductSubCat.length > 6 && (
                  <li
                    className="show-more"
                    onClick={() => setShowRemainingCategories(false)}
                    style={{
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display: collapsed ? "none" : "flex",
                        justifyContent: "flex-end",
                        padding: "10px 15px",
                        color: "var(--text-primary)",
                        fontSize: "medium",
                        textDecoration: "none",
                        fontWeight: 600,
                        transition: "all 0.5s ease",
                        borderRadius: "5px",
                        minHeight: "40px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className="mt-1"
                        style={{
                          color: "var(--text-secondary)",
                          transition: "color 0.5s ease",
                        }}
                      >
                        Show Less
                      </span>
                    </div>
                  </li>
                )}
                {/* <BusinessFilter selectedCat={selectedSubCategory} /> */}
                <ZipcodeFilter
                  collapsed={collapsed}
                  searchTerm={searchTerm}
                  setRadius={setRadius}
                  setSearchTerm={setSearchTerm}
                  tglHide={tglHide}
                  isTabletView={isTabletView}
                  toggled={toggled}
                  tempRadius={tempRadius}
                  handleRadiusChange={handleRadiusChange}
                  handleRadiusCommit={handleRadiusCommit}
                  type="lca"
                />
              </ul>
            )}
          </nav>
          {!loading && showPopup && (
            <Popup closePopup={() => setShowPopup(false)} />
          )}
        </div>
      </div>
      {!isMobileView && !isTabletView && (
        <a
          id="psb-btn-collapse"
          className="psb-collapser"
          onClick={handleCollapse}
        >
          <RiArrowLeftSLine />
        </a>
      )}
    </aside>
  );
};

export default LcaSideBar;
